export enum MyAccountViewPanelIds {
  Watchlist = 'watchlist',
  Portfolio = 'portfolio',
  Subscription = 'subscription',
  Security = 'security',
  Appearance = 'appearance',
}
